import { IPartnerFinSobRow } from '../../model/types'

import { RevenueMeasureField } from './types'

interface IParams {
  rows: IPartnerFinSobRow[]
  measureField: RevenueMeasureField
  currentFQuarter: number
  fQuarterActualsPercentage: number
}

/** In YTD mode the quarter still in progress has only partially happened, so its measure is
 *  scaled down by how far through that quarter today falls — a fully-closed prior quarter needs
 *  no such adjustment. Only the revenue measure is scaled; `sob` is a share, not an amount, so it
 *  stays as reported. */
export const prorateCurrentQuarterRows = ({
  rows,
  measureField,
  currentFQuarter,
  fQuarterActualsPercentage,
}: IParams): IPartnerFinSobRow[] =>
  rows.map((row) => {
    const value = row[measureField]

    if (row.fQuarter !== currentFQuarter || value === null) {
      return row
    }

    return { ...row, [measureField]: value * fQuarterActualsPercentage }
  })
